import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { FormControl, NgForm, Validators } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { BsModalService, ModalOptions, BsModalRef } from 'ngx-bootstrap/modal';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { PersonnesService } from '../../../../../services/frapper/personnes.service';
import { AlertesService } from '../../../../../services/public/alertes.service';
import { SignatairesService } from '../../../../../services/frapper/signataires.service';
import * as $ from 'jquery';
import { ConfigUserComponent } from '../../../config-user/config-user.component';

@Component({
  selector: 'ngx-view-details-signataire',
  templateUrl: './view-details-signataire.component.html',
  styleUrls: ['./view-details-signataire.component.scss']
})
export class ViewDetailsSignataireComponent {
  isLinear = true;
  my_tribunal: any = null
  data: any;
  type: any;
  listactions = []
  flags = ["AUTRE", "JUGEMENT", "CASIER", "NATURALISATION", "NATIONALITE", "PERMIS DE VISITE"]
  useTemplate: any = false;

  htmlContent: string = '<p>Ajouter ici le code HTML du template</p>';
  documentData: any[] = []
  list_signataires: any[] = []
  list_personnes = [];
  filteredPersons: any[] = [];
  selected_tribunal: any;
  rows: any[] = []
  modalRef!: BsModalRef;
  My_profil = ""
  autorized: boolean = false

  constructor(private modalService: BsModalService, public options: ModalOptions,
    private ngxService: NgxUiLoaderService,
    private alerte: AlertesService,
    private datePipe: DatePipe,
    private sanitizer: DomSanitizer,
    private bsModalRef: BsModalRef,
    private personneService: PersonnesService,
    private DefaultSignataireService: SignatairesService,
  ) {
    this.data = options.initialState
    this.my_tribunal = JSON.parse(localStorage.getItem('my_tribunal'))
    this.My_profil = localStorage.getItem('profil')
    if(this.My_profil == 'ADMIN TRIBUNAL'){
      this.autorized = true;
    }
    console.log('datat=>personne', this.data);
  }

  async onSubmit(form: NgForm) {
    this.ngxService.start()
    const personsData = this.getData()
    let document_tag = this.data.tag_documents;
    const docname = this.data.name;
    let body_content = {
      'tag_documents': document_tag,
      'tribunal': this.selected_tribunal.name,
      "signataire": personsData,
    }
    try {
      let result = await this.DefaultSignataireService.updateDefaulSignataire(docname, body_content)
      if (result != null) {
        this.closeWithMessage("success")
        this.alerte.successNotification("Modification signataires", "Liste Signataire Modifier !")
      } else {
        this.alerte.errorNotification("Modification liste signataire", "une erreur est survenue")
      }
    } catch (error) {
      this.alerte.errorNotification("Modification signataire", "une erreur est survenue")
    } finally {
      this.ngxService.stop()
    }
  }

  setData() {
    this.list_signataires.forEach(sig => {
      const person = this.list_personnes.find(p => p.name === sig.signataire);
      if (person) {
        const row = {
          NameControl: new FormControl(person.prenom + ' ' + person.nom, Validators.required),
          firstNameControl: new FormControl(person.name, Validators.required),
          lastNameControl: new FormControl(person.mail_professionel, Validators.required),
          professionControl: new FormControl(person.profession, Validators.required),
          phoneControl: new FormControl(sig.telephone || '', Validators.required),
        };
        this.rows.push(row);
      } else {
        console.warn(`Personne introuvable pour le signataire "${sig.signataire}"`);
      }
    });
  }

  getData() {
    const result = this.rows.map(row => {
      return {
        signataire: row.firstNameControl.value,
        nom_signataire: row.NameControl.value,
        email: row.lastNameControl.value,
        telephone: row.phoneControl.value,
        fonction: row.professionControl.value,
      };
    });
    return result;
  }

  addRow() {
    const row = {
      NameControl: new FormControl('', Validators.required),
      firstNameControl: new FormControl('', Validators.required),
      lastNameControl: new FormControl('', Validators.required),
      professionControl: new FormControl('', Validators.required),
      phoneControl: new FormControl('', Validators.required),
      hasContact: false
    };
    this.rows.push(row);
  }

  async onPersonChange(index: number) {
    const selectedFirstName = this.rows[index].firstNameControl.value;
    const person = this.list_personnes.find(t => t.name === selectedFirstName);
    let data = await this.getOnePerson(person.name);
    if (person) {
      this.rows[index].lastNameControl.setValue(person.mail_professionel || '');
      this.rows[index].NameControl.setValue((person.prenom || '') + ' ' + (person.nom || ''));
      this.rows[index].professionControl.setValue(person.profession || '');
      this.rows[index].hasContact = false;
      if (data.contact?.length) {
        for (const cont of data.contact) {
          if (cont.type === 'Telephone') {
            this.rows[index].phoneControl.setValue(cont.valeur);
            this.rows[index].hasContact = true;
            this.rows[index].phoneControl.clearValidators();
            this.rows[index].phoneControl.updateValueAndValidity();
            return;
          }
        }
      }
      if (!this.rows[index].hasContact) {
        this.rows[index].phoneControl.setValue('');
        this.rows[index].phoneControl.setValidators(Validators.required);
        this.rows[index].phoneControl.updateValueAndValidity();
      }
    }
  }

  deleteRow(index: number) {
    this.rows.splice(index, 1);
  }

  addRowBtn() {
    console.log('arise')
    this.addRow();
  }

  async getOnePerson(name){
    return (await this.personneService.getOnePersonne(name)).data
  }

  async getAllPersons() {
    this.ngxService.start()
    try {
      let filter = '[["tribunal_actuel" ,"=", "' + this.selected_tribunal.name + '"]]'
      this.list_personnes = (await this.personneService.getAllPersonne(filter)).data
    } catch (error) {
      console.log('erreur get tribunals', error);
    }
    finally {
      this.ngxService.stop()
    }
  }

  async refresh() {
    this.ngxService.start();
    try {
      await this.getAllSignataire()
      await this.getAllPersons();
      this.ngxService.stop()
    } catch (error) {
      this.ngxService.stop();
    }
  }

  async getUser(name) {
    const data = (await this.personneService.getOnePersonne(name)).data
    return data;
  }

  async detailSignataire(name) {
    const data = await this.getUser(name)
    const config: ModalOptions = {
      initialState: {
        'data': data
      }
    }
    return new Promise<string>((resolve, reject) => {
      this.modalRef = this.modalService.show(ConfigUserComponent, Object.assign({}, config, { class: 'modal-xl ' }));
      this.modalRef.content.parentModal = this.modalRef;
      this.modalRef.onHidden.subscribe(async (value: string) => {
        if (value == "success") {
          await this.refresh();
        }
      });
    }).then(async (value: string) => {
      this.refresh();
    });
  }

  get sanitizedHtml(): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(this.data.template);
  }

  getFormattedDate(date): string {
    return this.datePipe.transform(date, 'dd-MM-yyyy');
  }

  async getAllSignataire() {
    try {
      this.documentData = (await this.DefaultSignataireService.getOneDefaultSignataire(this.data.name)).data
      this.list_signataires = this.documentData['signataire'];
    } catch (error) {
      console.error('erreurrrr => getAllSignataire', error)
    }

  }

  closeModal() {
    this.bsModalRef.hide()
  }

  closeWithMessage(message: string) {
    this.bsModalRef.hide();
    this.bsModalRef.onHidden.emit(message);
  }

  async ngOnInit() {
    this.selected_tribunal = this.my_tribunal;
    await this.getAllSignataire()
    await this.getAllPersons()
    this.setData()
  }
}
